export interface SiteSettings {
  ISWLink?: string;
  maintenanceMessage?: string;
  maintenanceMode: boolean;
  softMaintenanceMode: boolean;
  alertToggle: boolean;
  alertMessage?: string;
}

export interface Settings {
  id: number;
  name: string;
  value: any;
  type: string;
  shortname: string;
}

export enum SettingsMapping {
  ISWLink = 'def_links',
  maintenanceMode = 'maint_mode',
  softMaintenanceMode = 'soft_maint_mode',
  maintenanceMessage = 'maint_msg',
  alertToggle = 'alert_exists',
  alertMessage = 'alert_msg',
  // used only on backend
  max_simultaneous_report_generate = 'max_simultaneous_report_generate',
  max_report_generation_time = 'max_report_generation_time',
  inventory_report_regenerate_lock_time = 'inventory_report_regenerate_lock_time',
  inventory_report_regenerate_last_execution = 'inventory_report_regenerate_last_execution',
  reports_remove_files_after_days = 'reports_remove_files_after_days',
  user_activity_report_regenerate_lock_time = 'user_activity_report_regenerate_lock_time',
  user_activity_report_regenerate_last_execution = 'user_activity_report_regenerate_last_execution'
}

export interface SettingsUpsert {
  value: any;
}

export interface ApiMapping {
  id: number;
  key: string;
}
